/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export const required = v => !!v || "Le champ est obligatoire";

export const equals = value => v =>
    v !== value ? "Les mots de passe doivent être identiques" : true;

export const email = v => {
    if (!v) return true;
    if (
        v &&
        !v.match(
            // eslint-disable-next-line no-control-regex
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/is
        )
    )
        return "Format d'email invalide";
    return true;
};

const matchAtLeastOne = (v, rules) => rules.some(rule => v.match(rule));

export const phone = v => {
    if (!v) return true;
    const rules = [/^\+33[0-9]{9}$/im, /^0[0-9]{9}$/im];
    if (!matchAtLeastOne(v, rules)) return "Numéro de téléphone invalide (à saisir sans espace)";
    return true;
};

export const siret = v => {
    if (!v) return true;
    if (v && !v.match(/^[0-9]{14}$/im)) return "Siret contient 14 chiffres sans espace";
    return true;
};

export const postalCode = v => {
    if (!v) return true;
    if (v && !v.match(/^[0-9]{5}$/im)) return "Code postal incorrect";
    return true;
};

export const passwordUpperCase = v => {
    const pattern = /^(?=.*[A-Z]).*$/;
    if (!pattern.test(v)) {
        return "Doit comporter un majuscule";
    }
    return true;
};

export const passwordLowerCase = v => {
    const pattern = /^(?=.*[a-z]).*$/;
    if (!pattern.test(v)) {
        return "Doit comporter un minuscule";
    }
    return true;
};

export const password8Char = v => {
    const pattern = /^.{8,}$/;
    if (!pattern.test(v)) {
        return "Doit comporter au moins 8 caractères";
    }
    return true;
};

export const passwordNumber = v => {
    const pattern = /^(?=.*[0-9]).*$/;
    if (!pattern.test(v)) {
        return "Doit comporter un chiffre";
    }
    return true;
};

export const passwordSpecialChar = v => {
    const pattern = /^(?=.*[@$!%*#?&<>+,:;=|'.^()_-]).*$/;
    if (!pattern.test(v)) {
        return "Doit comporter un caractère spécial";
    }
    return true;
};

export const concatRules =
    (...rules) =>
    v => {
        const rule = rules.find(rule => typeof rule(v) === "string");
        return rule ? rule(v) : true;
    };

export const password = concatRules(
    passwordUpperCase,
    passwordLowerCase,
    password8Char,
    passwordNumber,
    passwordSpecialChar
);
